import { Case, Specimen } from "pwapi";

import { CaseListDirection } from "../reducers/casesReducer";
import { CaseDetailState } from "reducers/caseDetailReducer";

export const getNextCaseId = (
  currentCaseId?: number,
  isListPending?: boolean,
  idList?: number[]
): number | undefined => {
  if (!currentCaseId || isListPending || !idList) {
    return undefined;
  }

  const caseIndex = idList.indexOf(currentCaseId);
  return caseIndex !== -1 && !(caseIndex >= idList.length - 1)
    ? idList[caseIndex + 1]
    : undefined;
};

export const getPrevCaseId = (
  currentCaseId?: number,
  isListPending?: boolean,
  idList?: number[]
): number | undefined => {
  if (!currentCaseId || isListPending || !idList) {
    return undefined;
  }

  const caseIndex = idList.indexOf(currentCaseId);
  return caseIndex !== -1 && !(caseIndex === 0)
    ? idList[caseIndex - 1]
    : undefined;
};

export const getCaseOrdering = (
  sortDirection: CaseListDirection = CaseListDirection.Asc,
  sortColumn: string
): string => {
  const descending = sortDirection === CaseListDirection.Desc ? "-" : "";
  return [
    "-priority",
    {
      accession: `${descending}accession`,
      clinician: `${descending}ordering_doctor`,
      patient: `${descending}patient__last_name,${descending}patient__first_name`,
      specimens__received_date: `${descending}specimens__received_date,${descending}accession_completed,${descending}created_at`,
      specimens__collected_date: `${descending}specimens__collected_date,${descending}accession_completed,${descending}created_at`,
      received_date: `${descending}received_date,${descending}accession_completed,${descending}created_at`,
      collected_date: `${descending}collected_date,${descending}accession_completed,${descending}created_at`,
    }[sortColumn] || `${descending}${sortColumn}`,
  ]
    .filter((a) => a)
    .join(",");
};

export const getSpecimenCollectedDate = (specimens: Specimen[]) => {
  return specimens.find((specimen) => specimen?.collected_date)?.collected_date;
};

const billingTypeLabels = {
  global: "Third-Party Bill",
  client: "Client Bill",
  cash: "Cash Pay",
  none: "No Bill",
};
export const billingTypeEnumToLabel = (shortEnum: Case.billing_type) => {
  return (shortEnum && billingTypeLabels[shortEnum]) || shortEnum;
};

export const isCaseTCOnly = (caseDetail: Case | CaseDetailState) => {
  const { bill_tc, bill_pc } = caseDetail;
  if (bill_tc && !bill_pc) return true;
  return false;
};
export const isCasePCOnly = (caseDetail: Case | CaseDetailState) => {
  const { bill_tc, bill_pc } = caseDetail;
  if (bill_pc && !bill_tc) return true;
  return false;
};
